import { Page, PageLinks, PageMeta } from '../../domain/entities/page';

import { RawJson, asRecord, readNumber, readString, unwrapCollection } from './raw-json';

function toPageMeta(payload: RawJson, itemCount: number): PageMeta {
  const meta = asRecord(payload['meta'] ?? payload['pagination']);
  const limit = readNumber(meta, 'limit', 'per_page', 'perPage') ?? itemCount;
  const total = readNumber(meta, 'total', 'count') ?? itemCount;
  const page = readNumber(meta, 'page', 'current_page', 'currentPage') ?? 1;
  const totalPages =
    readNumber(meta, 'totalPages', 'total_pages', 'pages') ??
    (limit > 0 ? Math.ceil(total / limit) : 1);

  return { total, page, limit, totalPages };
}

function toPageLinks(payload: RawJson): PageLinks {
  const links = asRecord(payload['links']);
  return {
    next: readString(links, 'next') ?? readString(payload, 'next'),
    prev: readString(links, 'prev', 'previous') ?? readString(payload, 'prev', 'previous'),
  };
}

export function toPage<T>(
  payload: unknown,
  mapItem: (raw: unknown) => T | null,
  ...collectionKeys: readonly string[]
): Page<T> {
  const record = asRecord(payload);
  const items = unwrapCollection(payload, ...collectionKeys)
    .map(mapItem)
    .filter((item): item is T => item !== null);

  return {
    items,
    meta: toPageMeta(record, items.length),
    links: toPageLinks(record),
  };
}
